"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileDropdownMenu = void 0;
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var MobileDropdown_1 = require("../../atoms/MobileDropdown");
var ListItem_1 = require("../../molecules/ListItem/ListItem");
var ProfileDropdownMenu = function (_a) {
    var menuItems = _a.menuItems, isOpen = _a.isOpen;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MobileDropdown_1.MobileDropdown, { isOpen: isOpen, menuPosition: { top: 88, left: 0 }, csx: { display: ["flex", "flex", "none"] } },
            react_1.default.createElement(MobileDropdown_1.DropdownContent, { alignItems: 'left' }, menuItems.map(function (_a) {
                var text = _a.text, rest = __rest(_a, ["text"]);
                return (react_1.default.createElement(MobileDropdown_1.DropdownLink, __assign({ key: text }, rest), text));
            }))),
        isOpen &&
            react_1.default.createElement(theme_ui_1.Box, { as: 'ul', sx: {
                    display: ["none", "none", "flex"],
                    background: __1.theme.colors.offBlack,
                    padding: 0,
                    width: "183px",
                    flexDirection: "column",
                    position: "absolute",
                    top: "108px",
                    right: ["109px", "109px", "109px", "109px", "205px", "353px"],
                    "::before": {
                        content: "''",
                        width: __1.theme.sizes[3],
                        height: "18px",
                        background: __1.theme.colors.offBlack,
                        clipPath: "polygon(50% 0, 0 100%, 100% 100%)",
                        position: "absolute",
                        right: "22px",
                        top: "-18px"
                    },
                } }, menuItems.map(function (_a) {
                var text = _a.text, rest = __rest(_a, ["text"]);
                return (react_1.default.createElement(ListItem_1.ListItem, __assign({ caption: text, key: text }, rest)));
            }))));
};
exports.ProfileDropdownMenu = ProfileDropdownMenu;
